import { SUPER_ADMIN_ROLE } from "@yalana/contracts";
import type { DashboardVariant } from "../components/WelcomeDashboard";

type RoleEntry = { roleName: string; isSystem?: boolean };

/**
 * Derive the dashboard variant from a list of user roles.
 * Extracted from useWelcomePage so Layout can reuse it for tour selection.
 *
 * userRole is the JWT-level role (auth_profiles.role). It is required as a
 * fallback for super-admins on fresh DBs where the data migration was skipped
 * and no customer_memberships row exists yet.
 */
export function deriveVariant(
  roles: RoleEntry[],
  userRole?: string,
): DashboardVariant {
  if (
    userRole === SUPER_ADMIN_ROLE ||
    roles.some((r) => r.isSystem || /admin/i.test(r.roleName))
  )
    return "admin";
  if (roles.some((role) => /manager/i.test(role.roleName)))
    return "sports-manager";
  if (roles.some((role) => /mechanic|technician/i.test(role.roleName)))
    return "mechanic";
  return "hotel-staff";
}
